import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import config from '../../../config';
import Axios from 'axios';
import { toggleSiteTheme } from '../../../Actions';
import '../../../log2base2.css';
// import { regionalLanguage } from '../../../Data/regionalLanguage';
import { specialCountries } from '../../../Data/specialCountries';
import { animatedRegionalsPaths, juniorsPaths, originalsPaths, partnerPlusPaths } from '../../../Data/excludedPaths';
import SiteLogo, { SiteDarkModeLogo } from '../SiteLogo';
import SiteButton from '../Button/siteButtons';
import ToggleSwitch from '../ToggleSwitch';
import CoursesLargeNav from './CoursesNavigation/CoursesLargeNav';
import CoursesMobileNav from './CoursesNavigation/CoursesMobileNav';
import SiteSideMenu from './SideNavigation';
import {
  HeaderOuter,
  HeaderInner,
  HeaderLogoIconWrapper,
  HeaderLogoWrapper,
  HeaderLogoText,
  HeaderNavBar,
  HeaderItem,
  HeaderLink,
  MobNav,
  MobList,
  MobSideMenuIcons,
  MobItem,
  MobLink,
  HamburgerIcon,
  DboardHamburgerWrapper,
  MobileHeader,
  MobileHeaderLogoWrapper,
  ThemeOptions,
  HeaderUserOptionsToggle,
  HeaderUserOptionsWrapper,
  HeaderGoldBtn,
} from './styles';
import { UserOptionDiv, UserOptionIcon, UserOptionDivText } from '../../Dashboard/Sections/styles/DboardSideNavbar';
// import { LargeRegionalsCourse, RegionalsLangDropdown, RegionalsLangWrapper, RegionalsLangIcon, MobileCourse, RegionalsLangText } from './CoursesNavigation/styles/index';
// import {MobilePricingContainer, MobPricingItem} from '../../Pricing/styles';
// import { PromoTrialSnackBar } from '../SnackBar';
import { RiArrowDownSLine, RiGroupLine, RiVipCrownFill } from 'react-icons/ri';
import { RxPerson, RxExit } from 'react-icons/rx';
import { FiMenu } from 'react-icons/fi';
import { HiOutlineUserGroup } from 'react-icons/hi2';

class Header extends Component {
  state = {
    menuOpen: false, // for header mobile side menu
    mobileCourses: false, // for mobileCourses dropdown
    pricingOption: false, // for pricingOption dropdown list on mobile
    isShowlanguageList: false, // for regionals dropdown
    mobilePackages: false, // for mobilePackages dropdown
    headerUserDropdown: false, // for header user options dropdown
  };

  toggleMobMenu = () => this.setState({ menuOpen: !this.state.menuOpen });
  closeMobMenu = () => this.setState({ menuOpen: false });

  handleMobCourses = () => {
    this.setState({
      mobileCourses: !this.state.mobileCourses,
      // pricingOption: false,
      // isShowlanguageList: false,
      mobilePackages: false,
    });
  };

  handleMobPackages = () => {
    this.setState({
      mobilePackages: !this.state.mobilePackages,
      mobileCourses: false,
      // pricingOption: false,
      // isShowlanguageList: false,
    });
  };

  toggleUserDropdown = () => {
    let { headerUserDropdown } = this.state;
    this.setState({ headerUserDropdown: !headerUserDropdown });
  };

  closeUserDropdown = () => this.setState({ headerUserDropdown: false });

  toggleTheme = async () => {
    const { darkTheme, toggleSiteTheme, userID, accessToken } = this.props;
    toggleSiteTheme(!darkTheme);

    if (userID) {
      let response = await Axios({
        method: 'post',
        url: `${config.dashboardServiceUrl}/lbtheme`,
        headers: {
          Authorization: 'Bearer ' + accessToken,
        },
        data: { themeStatus: !darkTheme },
      });
    }
  };

  navigateSpecialPricing = () => {
    window.location.href = '/special-offer-courses';
  };

  // handlePricingOptions = () => {
  //   this.setState({
  //     pricingOption: !this.state.pricingOption,
  //     mobileCourses: false,
  //   });
  // };

  // handleLanguageDropdownList = () => {
  //   this.setState({
  //     isShowlanguageList: !this.state.isShowlanguageList,
  //     pricingOption: false,
  //     mobileCourses: false,
  //     mobilePackages: false,
  //   });
  // };

  // handleRegionalLanguage = (id) => {
  //   window.location.href = `${config.domain}/${id}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=regionals-nav_bar`;
  // };

  render() {
    let {
      fixed,
      isDashboard,
      isCheckout,
      isPackage,
      fromPricing,
      variant,
      isFromInterview,
      isFromRegionalsMain,
      language,
      coursesLanguage,
      courseCategory,
      isScrolling,
      userID,
      headerSnackbar,
      showTrialExpiredBar,
      headerOfferSnackbar,
      toggleMobileSideBar,
      toggleLandscapeSideMenu,
      openLogoutModal,
      handleTabNavigation,
      history,
      dashboardPricing,
      promoSnackbar,
      darkTheme,
      paidPath,
      picture,
      primeOfferPriceLoading,
      primeOfferPrice,
      primeOfferLink,
    } = this.props;
    const { menuOpen, mobileCourses, isShowlanguageList, mobilePackages, headerUserDropdown } = this.state;
    let pathName = window.location.pathname;
    let cloudFront = config.cloudFront;

    let pricingLink = `/pricing/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=pricing-nav_bar`;
    let signInLink = `/login/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=login-nav_bar`;
    let signUpLink = `/signup/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=jff-nav_btn`;
    let specialBuyBtnText = this.props.country === 'IN' ? 'Buy Courses at ₹999' : 'Buy Courses at $14';

    let partnerPlusLink = `/partner-plus/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=ptnr-hmp-nav_bar`;
    let partnerPricingLink = `/partner-plus-pricing/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=ptnr-pricing-nav_bar`;
    let regionalsLink = `/regionals/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=rgnl-hmp-nav_bar`;
    let regionalsPricingLink = `/regionals-${language}-pricing/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=rgnl-pricing-nav_bar`;
    let expertPricingLink = `/${language}-expert-pricing/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=rgnl-pricing-nav_bar`;
    let codeJuniorsLink = `/code-juniors/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=cdjns-hmp-nav_bar`;
    let juniorsPricingLink = `/code-juniors-pricing/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=cdjns-pricing-nav_bar`;
    let groupPurchaseLink = `/student-group-purchase/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=std-off-dboard_nav_bar`;

    let individualSpecialPriceText = userID ? 'Buy Courses @ ₹499' : 'Courses @ ₹499';
    let individualSpecialPriceFullText = 'Buy Courses @ ₹499';
    let individualsSpecialPriceLink = '/byc-ppp-1932a93c2c3';

    let noPaidPath = !this.props.userPaidStatus || paidPath === undefined;
    let originalsSpecialIndividuals = paidPath && originalsPaths.every((path) => !paidPath.includes(path));
    let partnerPlusSpecialIndividuals = paidPath && partnerPlusPaths.every((path) => !paidPath.includes(path));
    let juniorsSpecialIndividuals = paidPath && juniorsPaths.every((path) => !paidPath.includes(path));
    let regionalsSpecialIndividuals = paidPath && animatedRegionalsPaths.every((path) => !paidPath.includes(path)) && !paidPath.includes(`prime-membership-${language}`);
    let expertSpecialIndividuals = paidPath && !paidPath.includes(`${language}-expert-membership`);

    return (
      <Fragment>
        {/* promoSnackbar && <PromoTrialSnackBar name = {this.props.userName} history={history} /> */}
        <HeaderOuter
          id="header"
          fixed={fixed}
          isDashboard={isDashboard}
          isFromInterview={isFromInterview}
          isScrolling={isScrolling}
          headerSnackbar={headerSnackbar}
          showTrialExpiredBar={showTrialExpiredBar}
          headerOfferSnackbar={headerOfferSnackbar}
        >
          {isCheckout ? (
            <HeaderInner>
              <div className="d-flex justify-content-center align-items-center">
                <HeaderLogoWrapper>
                  <SiteLogo />
                </HeaderLogoWrapper>
              </div>
            </HeaderInner>
          ) : isDashboard ? (
            <HeaderInner isDashboard={isDashboard}>
              <div className="d-flex justify-content-center align-items-center">
                <div className="d-lg-none">
                  <DboardHamburgerWrapper darkTheme={darkTheme} onClick={() => toggleMobileSideBar()}>
                    <FiMenu />
                  </DboardHamburgerWrapper>
                </div>
                {/*<div className="d-none d-lg-inline-block">
                  <DboardHamburgerWrapper darkTheme={darkTheme} onClick={() => toggleLandscapeSideMenu()}>
                    <FiMenu />
                  </DboardHamburgerWrapper>
                </div>*/}
                <a href={userID ? '/dashboard' : '/'}>
                  <HeaderLogoWrapper>{darkTheme ? <SiteDarkModeLogo /> : <SiteLogo />}</HeaderLogoWrapper>
                </a>
                {/* desktop header links */}
                <HeaderNavBar>
                  {/* landscape courses list */}
                  <CoursesLargeNav
                    language={language}
                    isFromInterview={isFromInterview}
                    country={this.props.country}
                    isDashboard={isDashboard}
                    darkTheme={darkTheme}
                    primeOfferPrice={primeOfferPrice}
                    primeOfferPriceLoading={primeOfferPriceLoading}
                    primeOfferLink={primeOfferLink}
                  />

                  {/* landscape packages list */}
                  {noPaidPath || originalsSpecialIndividuals || partnerPlusSpecialIndividuals ? (
                    <CoursesLargeNav packagesDropdown isFromInterview={isFromInterview} country={this.props.country} isDashboard={isDashboard} darkTheme={darkTheme} />
                  ) : null}

                  {noPaidPath || originalsSpecialIndividuals ? (
                    <HeaderItem isDashboard={isDashboard} onClick={() => dashboardPricing()}>
                      Pricing
                    </HeaderItem>
                  ) : null}
                </HeaderNavBar>
              </div>

              {/* desktop header buttons */}
              <div className="d-flex justify-content-center align-items-center">
                {/*<div className="d-none d-xl-flex align-items-center" style={{ marginLeft: '14px' }}>
                  <HeaderLink isFromInterview={darkTheme} href={groupPurchaseLink} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 'unset' }}>
                    Group purchase
                  </HeaderLink>
                  <span className="site-badge text-white fs-11 no-line-height ml-1" style={{ background: 'var(--primary)' }}>
                    NEW
                  </span>
                </div>*/}

                {/*{(this.props.country === 'IN' || specialCountries.ppp1.includes(this.props.country)) &&
                (noPaidPath || originalsSpecialIndividuals ? (
                  <div className="d-none d-lg-inline-block mr-4">
                    <SiteButton pricingBarBtn style={{ width: '170px', padding: '8px 4px', fontWeight: '500' }} onClick={this.navigateSpecialPricing}>
                      {specialBuyBtnText}
                    </SiteButton>
                  </div>
                ) : null}*/}

                {/*<div className="d-none d-lg-flex align-items-center ml-3">
                  <HeaderGoldBtn onClick={() => window.open('/gold-pass', '_blank', 'noopener,noreferrer')}>
                    <RiVipCrownFill /> Gold pass
                  </HeaderGoldBtn>
                </div>*/}

                {this.props.country === 'IN' && (noPaidPath || originalsSpecialIndividuals || regionalsSpecialIndividuals || partnerPlusSpecialIndividuals) ? (
                  <div className="d-none d-lg-flex align-items-center" style={{ marginLeft: '14px' }}>
                    <HeaderLink darkTheme={darkTheme} href={individualsSpecialPriceLink} style={{ marginLeft: 'unset' }}>
                      {individualSpecialPriceFullText}
                    </HeaderLink>
                  </div>
                ) : null}

                <div className="d-flex align-items-center ml-3 ml-lg-4">
                  <ToggleSwitch themeToggler={true} checked={darkTheme} onChange={this.toggleTheme} darkTheme={darkTheme} />
                </div>
                <HeaderUserOptionsToggle onClick={this.toggleUserDropdown} tabIndex={-1} onBlur={this.closeUserDropdown}>
                  <img className="img-fluid" src={picture} alt="" style={{ borderRadius: '25px' }} />

                  {headerUserDropdown ? (
                    <HeaderUserOptionsWrapper>
                      <UserOptionDiv
                        onClick={async () => {
                          this.closeUserDropdown();
                          await handleTabNavigation('My Account', '/dashboard/account');
                        }}
                      >
                        <UserOptionIcon>
                          <RxPerson />
                        </UserOptionIcon>
                        <UserOptionDivText>Account</UserOptionDivText>
                      </UserOptionDiv>

                      <UserOptionDiv onClick={() => openLogoutModal()}>
                        <UserOptionIcon>
                          <RxExit />
                        </UserOptionIcon>
                        <UserOptionDivText>Log out</UserOptionDivText>
                      </UserOptionDiv>
                    </HeaderUserOptionsWrapper>
                  ) : null}
                </HeaderUserOptionsToggle>
              </div>
            </HeaderInner>
          ) : (
            <HeaderInner>
              <div className="d-flex justify-content-center align-items-center">
                <div className="d-lg-none no-line-height">
                  <HamburgerIcon isFromInterview={isFromInterview} onClick={this.toggleMobMenu} />
                </div>
                <a
                  href={
                    userID
                      ? '/dashboard'
                      : variant === 'partner-plus'
                      ? '/partner-plus'
                      : isFromRegionalsMain
                      ? '/regionals'
                      : variant === 'regionals'
                      ? `/${language}`
                      : variant === 'code-juniors'
                      ? '/code-juniors'
                      : '/'
                  }
                >
                  {variant === 'partner-plus' ? (
                    <div className="d-flex align-items-center">
                      <HeaderLogoIconWrapper>
                        <img className="img-fluid" src={cloudFront + '/Assets/metaImages/SiteAppIcon.png'} alt="Partner+ Courses" />
                      </HeaderLogoIconWrapper>
                      <HeaderLogoText>Partner+</HeaderLogoText>
                    </div>
                  ) : variant === 'regionals' ? (
                    <div className="d-flex align-items-center">
                      <HeaderLogoIconWrapper>
                        <img className="img-fluid" src={cloudFront + '/Assets/metaImages/SiteAppIcon.png'} alt="Regionals" />
                      </HeaderLogoIconWrapper>
                      <HeaderLogoText>{coursesLanguage ? <span className="weight-600">{coursesLanguage}</span> : 'Regionals'}</HeaderLogoText>
                    </div>
                  ) : variant === 'code-juniors' ? (
                    <div className="d-flex align-items-center">
                      <HeaderLogoIconWrapper>
                        <img className="img-fluid" src={cloudFront + '/Assets/metaImages/SiteAppIcon.png'} alt="Code Juniors" />
                      </HeaderLogoIconWrapper>
                      <HeaderLogoText>Juniors</HeaderLogoText>
                    </div>
                  ) : (
                    <HeaderLogoWrapper>{isFromInterview ? <SiteDarkModeLogo /> : <SiteLogo />}</HeaderLogoWrapper>
                  )}
                </a>

                {/* desktop header links */}
                <HeaderNavBar>
                  {/* landscape courses list */}
                  <CoursesLargeNav
                    variant={variant}
                    language={language}
                    courseCategory={courseCategory}
                    isFromInterview={isFromInterview}
                    country={this.props.country}
                    primeOfferPrice={primeOfferPrice}
                    primeOfferPriceLoading={primeOfferPriceLoading}
                    primeOfferLink={primeOfferLink}
                  />
                  {/* landscape packages list */}
                  {variant !== 'code-juniors' && variant !== 'regionals' && (
                    <CoursesLargeNav packagesDropdown variant={variant} isFromInterview={isFromInterview} country={this.props.country} />
                  )}

                  {variant === 'partner-plus' ? (
                    <Fragment>
                      {/*<CoursesLargeNav variant={variant} language={language} country={this.props.country} />*/}
                      {/*<CoursesLargeNav packagesDropdown variant={variant} isFromInterview={isFromInterview} country={this.props.country} />*/}
                      {noPaidPath || partnerPlusSpecialIndividuals ? (
                        <HeaderLink desktopLink href={pricingLink}>
                          Pricing
                        </HeaderLink>
                      ) : null}
                    </Fragment>
                  ) : variant === 'regionals' ? (
                    <Fragment>
                      {/*{isFromRegionalsMain ? (
                        <CoursesLargeNav isFromRegionalsMain variant={variant} language={language} isFromInterview={isFromInterview} country={this.props.country} />
                      ) : (
                        <Fragment>
                          <CoursesLargeNav variant={variant} language={language} coursesLanguage={coursesLanguage} courseCategory={courseCategory} country={this.props.country} />
                          </Fragment>
                        )}*/}
                      {courseCategory === 'professional' ? (
                        <Fragment>
                          {noPaidPath || expertSpecialIndividuals ? (
                            <HeaderLink desktopLink href={expertPricingLink}>
                              Pricing
                            </HeaderLink>
                          ) : null}
                        </Fragment>
                      ) : (
                        <Fragment>
                          {noPaidPath || regionalsSpecialIndividuals ? (
                            <HeaderLink desktopLink href={pricingLink}>
                              Pricing
                            </HeaderLink>
                          ) : null}
                        </Fragment>
                      )}
                    </Fragment>
                  ) : variant === 'code-juniors' ? (
                    <Fragment>
                      {/*<CoursesLargeNav variant={variant} country={this.props.country} />*/}
                      {noPaidPath || (paidPath && juniorsPaths.every((path) => !paidPath.includes(path))) ? (
                        <HeaderLink desktopLink href={pricingLink}>
                          Pricing
                        </HeaderLink>
                      ) : null}
                    </Fragment>
                  ) : (
                    <Fragment>
                      {/*<CoursesLargeNav language={language} isFromInterview={isFromInterview} country={this.props.country} />
                      <CoursesLargeNav packagesDropdown isFromInterview={isFromInterview} country={this.props.country} />*/}

                      {/* landscape regionals list */}
                      {/*{this.props.country === 'IN' && (
                        <RegionalsLangDropdown style={{ marginLeft: '14px' }}>
                          <HeaderItem noMargin isFromInterview={isFromInterview}>Regionals<RiArrowDownSLine /></HeaderItem>
                          <RegionalsLangWrapper>
                            {regionalLanguage.map(({ id, img, title }) => (
                              <LargeRegionalsCourse key={id} onClick={() => this.handleRegionalLanguage(id)}><RegionalsLangIcon src={cloudFront + img} /><RegionalsLangText txtColor={title}>{title}</RegionalsLangText></LargeRegionalsCourse>
                            ))}
                          </RegionalsLangWrapper>
                        </RegionalsLangDropdown>
                      )}*/}

                      {noPaidPath || originalsSpecialIndividuals ? (
                        <HeaderLink desktopLink isFromInterview={isFromInterview} href={pricingLink}>
                          Pricing
                        </HeaderLink>
                      ) : null}
                    </Fragment>
                  )}

                  {/* <HeaderLink desktopLink isFromInterview={isFromInterview} href={'/student-group-purchase'}>Group Purchase<span className="site-badge bg-primary text-light fs-12 ml-1">NEW</span></HeaderLink> */}
                  {/* <HeaderLink desktopLink isFromInterview={isFromInterview} href="/business">Business</HeaderLink> */}
                  {/* <HeaderLink desktopLink isFromInterview={isFromInterview} href="https://hirefreshers.log2base2.com/">Hire Freshers</HeaderLink> */}
                  {/* <HeaderLink desktopLink isFromInterview={isFromInterview} href='/reviews'>Success Stories</HeaderLink> */}
                </HeaderNavBar>
              </div>

              {/* desktop header buttons */}
              <div className="d-flex justify-content-center align-items-center">
                {/*{!fromPricing &&
                (this.props.country === 'IN' || specialCountries.ppp1.includes(this.props.country)) &&
                (noPaidPath || originalsSpecialIndividuals ? (
                  <div className="d-none d-lg-inline-block">
                    <SiteButton pricingBarBtn style={{ width: '170px', padding: '8px 4px', fontWeight: '500' }} onClick={this.navigateSpecialPricing}>
                      {specialBuyBtnText}
                    </SiteButton>
                  </div>
                ) : null}*/}

                {/*{variant !== 'partner-plus' && variant !== 'regionals' && variant !== 'code-juniors' ? (
                  <div className="d-none d-lg-flex align-items-center" style={{ marginLeft: '14px' }}>
                    <HeaderLink isFromInterview={isFromInterview} variant={variant} href={'/student-offer'} style={{ marginLeft: 'unset' }}>
                      Student offer
                    </HeaderLink>{' '}
                    <span className="hide-till-large-laptop site-badge bg-primary text-light fs-11 ml-1">NEW</span>
                  </div>
                ) : null}*/}

                {this.props.country === 'IN' &&
                variant !== 'code-juniors' &&
                (noPaidPath || originalsSpecialIndividuals || regionalsSpecialIndividuals || partnerPlusSpecialIndividuals) ? (
                  <div className="d-none d-lg-flex align-items-center" style={{ marginLeft: '14px' }}>
                    <HeaderLink isFromInterview={isFromInterview} href={individualsSpecialPriceLink} style={{ marginLeft: 'unset' }}>
                      {individualSpecialPriceText}
                    </HeaderLink>
                  </div>
                ) : null}

                {/*{variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? (
                  <div className="d-none d-lg-flex align-items-center" style={{ marginLeft: '14px' }}>
                    <HeaderLink variant={variant} href={userID ? '/dashboard' : '/'} style={{ marginLeft: 'unset' }}>
                      Originals
                    </HeaderLink>
                  </div>
                ) : null}*/}

                {/*{variant !== 'regionals' && this.props.country === 'IN' ? (
                  <div className="d-none d-lg-flex align-items-center" style={{ marginLeft: '14px' }}>
                    <HeaderLink isFromInterview={isFromInterview} variant={variant} href={regionalsLink} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 'unset' }}>
                      Regionals
                    </HeaderLink>
                  </div>
                ) : null}
                {variant !== 'partner-plus' ? (
                  <div className="d-none d-lg-flex align-items-center" style={{ marginLeft: '14px' }}>
                    <HeaderLink
                      isFromInterview={isFromInterview}
                      variant={variant}
                      href={partnerPlusLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginLeft: 'unset' }}
                    >
                      Partner+ <span className="text-inheritance d-none d-xl-inline ml-1">courses</span>
                    </HeaderLink>
                  </div>
                ) : null}
                {variant !== 'code-juniors' && (variant === 'partner-plus' || variant === 'regionals') ? (
                  <div className="d-none d-lg-flex align-items-center" style={{ marginLeft: '14px' }}>
                    <HeaderLink
                      isFromInterview={isFromInterview}
                      variant={variant}
                      href={codeJuniorsLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginLeft: 'unset' }}
                    >
                      <span className="text-inheritance d-xl-none">Juniors</span>
                      <span className="text-inheritance d-none d-xl-inline">Code juniors</span>
                    </HeaderLink>
                  </div>
                ) : null}*/}

                {this.props.country === 'IN' && (
                  <Fragment>
                    <HeaderLink desktopLink isFromInterview={isFromInterview} style={{ marginLeft: '16px' }} href={`tel:${'+919566269470'}`} data-tip="+91 9566269470">
                      <img
                        src={isFromInterview ? '/Assets/IconsPack/sidemenu-phone-icon-white.svg' : '/Assets/IconsPack/sidemenu-phone-icon-black.svg'}
                        style={{ width: '16px', height: '16px' }}
                        alt="call support"
                      />
                      {/*<span id="headerMobLink" className="text-inheritance d-none d-lg-inline">+91 9566269470</span>*/}
                    </HeaderLink>
                    <ReactTooltip place="bottom" effect="solid" />
                  </Fragment>
                )}

                {!userID && (
                  <Fragment>
                    <div className="d-none d-lg-flex align-items-lg-center">
                      {!(pathName === '/login' || pathName === '/login/' || pathName === '/signup' || pathName === '/signup/') && (
                        <Fragment>
                          {/*<HeaderLink desktopLink style={{ marginLeft: '14px', color: 'var(--brandColor)' }} href={`${config.domain}${signInLink}`}>Sign in</HeaderLink>*/}
                          <a className="d-none d-lg-inline-block" href={`${config.domain}${signInLink}`} style={{ marginLeft: '14px' }}>
                            {/*{variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? (
                              <button className="text-white custom-btn" style={{ height: '40px', minWidth: '75px', background: 'transparent' }}>
                                Sign in
                              </button>
                            ) : (
                            )}*/}
                            <SiteButton ghostBtn darkTheme={isFromInterview} style={{ height: '40px', minWidth: '75px' }}>
                              Sign in
                            </SiteButton>
                          </a>
                        </Fragment>
                      )}

                      {isPackage ? (
                        <Fragment>
                          {!userID ? (
                            <a className="d-inline-block" style={{ marginLeft: '12px' }} href={`${config.domain}${signUpLink}`}>
                              {/*{variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? (
                                <button className="bg-white custom-btn" style={{ height: '40px', minWidth: '80px', padding: '8px 12px', color: 'var(--partnerDarkTxt)' }}>
                                  Join for free
                                </button>
                              ) : (
                              )}*/}
                              <SiteButton style={{ height: '40px', minWidth: '80px', padding: '8px 12px' }}>Join for free</SiteButton>
                            </a>
                          ) : (
                            <a className="d-inline-block" style={{ marginLeft: '12px' }} href={`${config.domain}/dashboard`}>
                              {/*{variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? (
                                <button className="bg-white custom-btn" style={{ height: '40px', minWidth: '80px', padding: '8px 12px', color: 'var(--partnerDarkTxt)' }}>
                                  Join for free
                                </button>
                              ) : (
                              )}*/}
                              <SiteButton style={{ height: '40px', minWidth: '80px', padding: '8px 12px' }}>Join for free</SiteButton>
                            </a>
                          )}
                        </Fragment>
                      ) : pathName === '/login' || pathName === '/login/' ? (
                        <a className="d-inline-block" style={{ marginLeft: '14px' }} href={`${config.domain}${signUpLink}`}>
                          <SiteButton style={{ padding: '8px 12px' }}>Sign up</SiteButton>
                        </a>
                      ) : pathName === '/signup' || pathName === '/signup/' ? (
                        <a className="d-inline-block" style={{ marginLeft: '14px' }} href={`${config.domain}${signInLink}`}>
                          <SiteButton style={{ padding: '8px 12px' }}>Sign in</SiteButton>
                        </a>
                      ) : null}

                      {!isPackage && pathName !== '/login' && pathName !== '/login/' && pathName !== '/signup' && pathName !== '/signup/' && (
                        <a className="d-inline-block" style={{ marginLeft: '12px' }} href={`${config.domain}${signUpLink}`}>
                          {/*{variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? (
                            <button className="bg-white custom-btn" style={{ height: '40px', minWidth: '80px', padding: '8px 12px', color: 'var(--partnerDarkTxt)' }}>
                              Join for free
                            </button>
                          ) : (
                          )}*/}
                          <SiteButton style={{ padding: '8px 12px' }}>Join for free</SiteButton>
                        </a>
                      )}
                    </div>

                    {/* mobile header links */}
                    {pathName === '/login' || pathName === '/login/' ? (
                      <HeaderLink mobileLink isFromInterview={isFromInterview} href={signUpLink} style={{ color: 'var(--brandColor)' }}>
                        Sign up
                      </HeaderLink>
                    ) : (
                      <HeaderLink
                        mobileLink
                        href={signInLink}
                        style={{
                          color: `${isFromInterview ? 'var(--light)' : 'var(--brandColor)'}`,
                        }}
                      >
                        Sign in
                      </HeaderLink>
                    )}
                  </Fragment>
                )}
              </div>
            </HeaderInner>
          )}
        </HeaderOuter>

        <Fragment>
          {/* mobile menu */}
          {menuOpen && (
            <MobNav showTrialExpiredBar={showTrialExpiredBar} headerOfferSnackbar={headerOfferSnackbar}>
              <SiteSideMenu isFromInterview={isFromInterview} closeSideMenu={() => this.closeMobMenu()}>
                <MobileHeader isFromInterview={isFromInterview}>
                  <HamburgerIcon isFromInterview={isFromInterview} onClick={() => this.closeMobMenu()} />
                  <a
                    href={
                      userID
                        ? '/dashboard'
                        : variant === 'partner-plus'
                        ? '/partner-plus'
                        : isFromRegionalsMain
                        ? '/regionals'
                        : variant === 'regionals'
                        ? `/${language}`
                        : variant === 'code-juniors'
                        ? '/code-juniors'
                        : '/'
                    }
                  >
                    {variant === 'partner-plus' ? (
                      <div className="d-flex align-items-center">
                        <HeaderLogoIconWrapper>
                          <img className="img-fluid" src={cloudFront + '/Assets/metaImages/SiteAppIcon.png'} alt="Partner+ Courses" />
                        </HeaderLogoIconWrapper>
                        <HeaderLogoText>Partner+</HeaderLogoText>
                      </div>
                    ) : variant === 'regionals' ? (
                      <div className="d-flex align-items-center">
                        <HeaderLogoIconWrapper>
                          <img className="img-fluid" src={cloudFront + '/Assets/metaImages/SiteAppIcon.png'} alt="Regionals" />
                        </HeaderLogoIconWrapper>
                        <HeaderLogoText>{coursesLanguage ? <span className="weight-600">{coursesLanguage}</span> : 'Regionals'}</HeaderLogoText>
                      </div>
                    ) : variant === 'code-juniors' ? (
                      <div className="d-flex align-items-center">
                        <HeaderLogoIconWrapper>
                          <img className="img-fluid" src={cloudFront + '/Assets/metaImages/SiteAppIcon.png'} alt="Code Juniors" />
                        </HeaderLogoIconWrapper>
                        <HeaderLogoText>Juniors</HeaderLogoText>
                      </div>
                    ) : (
                      <MobileHeaderLogoWrapper>{isFromInterview ? <SiteDarkModeLogo /> : <SiteLogo />}</MobileHeaderLogoWrapper>
                    )}
                  </a>
                </MobileHeader>

                <MobList>
                  {variant !== 'code-juniors' && (
                    <Fragment>
                      {/* mobile courses list */}
                      <MobItem onClick={this.handleMobCourses}>
                        <div className={`d-flex align-items-center ${isFromInterview ? 'text-light' : 'darkGreyTxt'}`}>
                          <MobSideMenuIcons src={isFromInterview ? '/Assets/sidemenu-courses-icon-white.svg' : '/Assets/sidemenu-courses-icon.svg'} alt="courses" /> Browse Courses
                        </div>
                        <RiArrowDownSLine className={`fs-20 ${isFromInterview ? 'text-light' : 'darkGreyTxt'}`} />
                      </MobItem>
                      {mobileCourses && (
                        <CoursesMobileNav variant={variant} isFromInterview={isFromInterview} language={language} courseCategory={courseCategory} country={this.props.country} />
                      )}

                      {/* mobile packages list */}
                      {variant !== 'regionals' && (noPaidPath || originalsSpecialIndividuals || partnerPlusSpecialIndividuals) ? (
                        <Fragment>
                          <MobItem onClick={this.handleMobPackages}>
                            <div className={`d-flex align-items-center ${isFromInterview ? 'text-light' : 'darkGreyTxt'}`}>
                              <MobSideMenuIcons src={isFromInterview ? '/Assets/sidemenu-packages-icon-white.svg' : '/Assets/sidemenu-packages-icon.svg'} alt="packages" /> Packages
                            </div>
                            <RiArrowDownSLine className={`fs-20 ${isFromInterview ? 'text-light' : 'darkGreyTxt'}`} />
                          </MobItem>
                          {mobilePackages && (
                            <CoursesMobileNav packagesDropdown variant={variant} isFromInterview={isFromInterview} courseCategory={courseCategory} country={this.props.country} />
                          )}
                        </Fragment>
                      ) : null}
                    </Fragment>
                  )}

                  {variant === 'partner-plus' ? (
                    <Fragment>
                      {noPaidPath || partnerPlusSpecialIndividuals ? (
                        <MobLink href={pricingLink} isFromInterview={isFromInterview}>
                          <MobSideMenuIcons src={isFromInterview ? '/Assets/sidemenu-pricing-icon-white.svg' : '/Assets/sidemenu-pricing-icon.svg'} alt="pricing" /> Pricing
                        </MobLink>
                      ) : null}
                    </Fragment>
                  ) : variant === 'regionals' ? (
                    <Fragment>
                      {courseCategory === 'professional' ? (
                        <Fragment>
                          {noPaidPath || expertSpecialIndividuals ? (
                            <MobLink href={expertPricingLink} isFromInterview={isFromInterview}>
                              <MobSideMenuIcons src={isFromInterview ? '/Assets/sidemenu-pricing-icon-white.svg' : '/Assets/sidemenu-pricing-icon.svg'} alt="pricing" /> Pricing
                            </MobLink>
                          ) : null}
                        </Fragment>
                      ) : (
                        <Fragment>
                          {noPaidPath || regionalsSpecialIndividuals ? (
                            <MobLink href={pricingLink} isFromInterview={isFromInterview}>
                              <MobSideMenuIcons src={isFromInterview ? '/Assets/sidemenu-pricing-icon-white.svg' : '/Assets/sidemenu-pricing-icon.svg'} alt="pricing" /> Pricing
                            </MobLink>
                          ) : null}
                        </Fragment>
                      )}
                    </Fragment>
                  ) : variant === 'code-juniors' ? (
                    <Fragment>
                      <MobItem onClick={this.handleMobCourses}>
                        <div className={`d-flex align-items-center ${isFromInterview ? 'text-light' : 'darkGreyTxt'}`}>
                          <MobSideMenuIcons
                            src={`${cloudFront}${
                              isFromInterview ? '/Assets/Dashboard/dashboard-juniors-icon-outline-light.svg' : '/Assets/Dashboard/dashboard-juniors-icon-outline.svg'
                            }`}
                            alt="courses"
                          />{' '}
                          Juniors courses
                        </div>
                        <RiArrowDownSLine className={`fs-20 ${isFromInterview ? 'text-light' : 'darkGreyTxt'}`} />
                      </MobItem>
                      {mobileCourses && <CoursesMobileNav variant={variant} isFromInterview={isFromInterview} courseCategory={courseCategory} country={this.props.country} />}

                      {noPaidPath || juniorsSpecialIndividuals ? (
                        <MobLink href={pricingLink} isFromInterview={isFromInterview}>
                          <MobSideMenuIcons src={isFromInterview ? '/Assets/sidemenu-pricing-icon-white.svg' : '/Assets/sidemenu-pricing-icon.svg'} alt="pricing" /> Pricing
                        </MobLink>
                      ) : null}
                    </Fragment>
                  ) : (
                    <Fragment>
                      {/* mobile regionals list */}
                      {/*{this.props.country === 'IN' && (
                        <MobItem onClick={this.handleLanguageDropdownList}>
                          <div className={`d-flex align-items-center ${(isFromInterview) ? 'darkWhiteTxt' : 'darkGreyTxt'}`}>
                            <MobSideMenuIcons src="/Assets/sidemenu-regionals-icon.svg" alt="regional languages" /> Regionals
                          </div>
                          <RiArrowDownSLine className={`fs-20 ${(isFromInterview) ? 'darkWhiteTxt' : 'darkGreyTxt'}`} />
                        </MobItem>
                      )}
                      {isShowlanguageList && (
                        <div style={{ backgroundColor: 'white', padding: '5px 0px' }}>height: fit-content;
                          {regionalLanguage.map(({ id, img, title }) => (
                            <MobileCourse key={id} onClick={() => this.handleRegionalLanguage(id)}>
                              <RegionalsLangIcon src={cloudFront + img} />
                              <RegionalsLangText txtColor={title}>{title}</RegionalsLangText>
                            </MobileCourse>
                          ))}
                        </div>
                          )}*/}

                      {/* <MobItem onClick={this.handlePricingOptions}>Pricing<RiArrowDownSLine /></MobItem>
                      {pricingOption && <MobileCoursesContainer tabIndex={3} onBlur={this.handleMobCourses}>
                        <MobilePricingContainer>
                          <MobPricingItem onClick={() => history.push('/pricing')}>For Individuals</MobPricingItem>
                          <MobPricingItem onClick={() => history.push('/pricing?student=true')}>For Students</MobPricingItem>
                        </MobilePricingContainer>
                      </MobileCoursesContainer>} */}
                      {/*<MobLink href="/business" isFromInterview = {isFromInterview}>Business</MobLink>*/}
                      {/*<MobLink href="https://hirefreshers.log2base2.com/" isFromInterview = {isFromInterview}>For Fresher Hiring <HomeNewTag isSmallDevice style={{ fontSize: '10px' }}>NEW</HomeNewTag></MobLink>*/}
                      {/*<MobLink href='/reviews' isFromInterview = {isFromInterview}>Success Stories</MobLink> */}
                      {/*<MobLink href={'/student-group-purchase'} isFromInterview={isFromInterview}>
                        <HiOutlineUserGroup className="brandTxt" style={{ width: '22px', marginRight: '12px' }} /> Group purchase
                        <span className="site-badge bg-primary text-light ml-2" style={{ fontSize: '10px' }}>NEW</span>
                      </MobLink>*/}

                      {noPaidPath || originalsSpecialIndividuals ? (
                        <MobLink href={pricingLink} isFromInterview={isFromInterview}>
                          <MobSideMenuIcons src={isFromInterview ? '/Assets/sidemenu-pricing-icon-white.svg' : '/Assets/sidemenu-pricing-icon.svg'} alt="pricing" /> Pricing
                        </MobLink>
                      ) : null}
                    </Fragment>
                  )}

                  {this.props.country === 'IN' &&
                  variant !== 'code-juniors' &&
                  (noPaidPath || originalsSpecialIndividuals || regionalsSpecialIndividuals || partnerPlusSpecialIndividuals) ? (
                    <MobLink href={individualsSpecialPriceLink} isFromInterview={isFromInterview}>
                      <MobSideMenuIcons src={isFromInterview ? '/Assets/sidemenu-pricing-icon-white.svg' : '/Assets/sidemenu-pricing-icon.svg'} alt="pricing" />{' '}
                      {individualSpecialPriceFullText}
                    </MobLink>
                  ) : null}

                  {/*{variant !== 'partner-plus' && variant !== 'regionals' && variant !== 'code-juniors' ? (
                    <MobLink href={userID ? '/dashboard' : '/'} isFromInterview={isFromInterview}>
                      <MobSideMenuIcons src={isFromInterview ? '/Assets/dboard-students-outline-light.svg' : '/Assets/dboard-students-outline-icon.svg'} alt="" /> Student offer
                      <span className="site-badge bg-primary text-light no-line-height ml-1" style={{ fontSize: '10px' }}>
                        NEW
                      </span>
                    </MobLink>
                  ) : null}*/}

                  {/*{variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? (
                    <MobLink href={userID ? '/dashboard' : '/'} isFromInterview={isFromInterview}>
                      <MobSideMenuIcons src={isFromInterview ? '/Assets/sidemenu-home-icon-white.svg' : '/Assets/sidemenu-home-icon.svg'} alt="" /> Originals
                    </MobLink>
                  ) : null}*/}

                  {/*{variant !== 'regionals' && this.props.country === 'IN' ? (
                    <MobLink href={regionalsLink} isFromInterview={isFromInterview} target="_blank" rel="noreferrer noopener">
                      <MobSideMenuIcons
                        src={`${cloudFront}${isFromInterview ? '/Assets/Dashboard/dboard-regionals-outline-light.svg' : '/Assets/Dashboard/dboard-regionals-outline.svg'}`}
                        alt=""
                      />
                      Regionals
                    </MobLink>
                  ) : null}

                  {variant !== 'partner-plus' ? (
                    <MobLink href={partnerPlusLink} isFromInterview={isFromInterview} target="_blank" rel="noreferrer noopener">
                      <MobSideMenuIcons
                        src={`${cloudFront}${isFromInterview ? '/Assets/Dashboard/dboard-partner-icon-outline-light.svg' : '/Assets/Dashboard/dboard-partner-icon-outline.svg'}`}
                        alt=""
                      />
                      Partner+ courses
                    </MobLink>
                  ) : null}

                  {variant !== 'code-juniors' && (variant === 'partner-plus' || variant === 'regionals') ? (
                    <MobLink href={codeJuniorsLink} isFromInterview={isFromInterview} target="_blank" rel="noreferrer noopener">
                      <MobSideMenuIcons
                        src={`${cloudFront}${
                          isFromInterview ? '/Assets/Dashboard/dashboard-juniors-icon-outline-light.svg' : '/Assets/Dashboard/dashboard-juniors-icon-outline.svg'
                        }`}
                        alt=""
                      />
                      Code juniors
                      <span className="site-badge juniors-bg-color text-white no-line-height ml-1" style={{ fontSize: '10px' }}>
                        KIDS
                      </span>
                    </MobLink>
                  ) : null}*/}

                  {this.props.country === 'IN' && (
                    <MobLink href={`tel:${'+919566269470'}`} isFromInterview={isFromInterview}>
                      <MobSideMenuIcons src={isFromInterview ? '/Assets/sidemenu-phone-icon-white.svg' : '/Assets/sidemenu-phone-icon.svg'} alt="call support" />
                      <span id="headerMobLink">+91 9566269470</span>
                    </MobLink>
                  )}

                  {/*{!fromPricing &&
                  (this.props.country === 'IN' || specialCountries.ppp1.includes(this.props.country)) &&
                  (noPaidPath || originalsSpecialIndividuals ? (
                    <div style={{ padding: '12px 18px' }}>
                      <SiteButton pricingBarBtn onClick={this.navigateSpecialPricing} style={{ fontWeight: '500' }}>{specialBuyBtnText}</SiteButton>
                    </div>
                  ) : null}*/}

                  {!userID && (
                    <Fragment>
                      <hr className="w-100 mt-4" style={{ borderTopColor: isFromInterview ? 'var(--inputTxtColor)' : 'var(--greyShadowColor)' }} />
                      <MobItem nonClickable style={{ justifyContent: 'center' }}>
                        <a className="d-inline-block mr-3" href={`${config.domain}${signInLink}`}>
                          <SiteButton ghostBtn darkTheme={isFromInterview} style={{ height: '42px', width: '115px', padding: '4px 16px' }}>
                            Sign in
                          </SiteButton>
                        </a>
                        <a className="d-inline-block" href={`${config.domain}${signUpLink}`}>
                          <SiteButton style={{ height: '42px', width: '115px', padding: '8px 12px' }}>Sign up</SiteButton>
                        </a>
                      </MobItem>
                    </Fragment>
                  )}
                </MobList>
              </SiteSideMenu>
            </MobNav>
          )}
        </Fragment>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ User, Dashboard }) => ({
  userID: User.username,
  userName: User.name,
  picture: User.picture,
  darkTheme: User.darkTheme && User.darkTheme,
  userPaidStatus: Dashboard.trialAndInProgress && Dashboard.trialAndInProgress.paidStatus,
  accessToken: User.token,
  paidPath: Dashboard.trialAndInProgress && Dashboard.trialAndInProgress.path,
  country: User.locationDetails && User.locationDetails.country,
});

const mapDispatchToProps = (dispatch) => ({ toggleSiteTheme: (themeStatus) => dispatch(toggleSiteTheme(themeStatus)) });

export default connect(mapStateToProps, mapDispatchToProps)(Header);
